import api from '@shared/services/api';

export const signeesService = {
    getAllSignees: async (searchParams = {}, paginationParams = {}) => {
        try {
            const params = new URLSearchParams();
            
            if (paginationParams.pageNumber !== undefined) {
                params.append('page', paginationParams.pageNumber);
            }
            if (paginationParams.pageSize !== undefined) {
                params.append('size', paginationParams.pageSize);
            }
            
            if (searchParams.personName) {
                params.append('name', searchParams.personName.trim());
            }
            if (searchParams.personFatherName) {
                params.append('fathersName', searchParams.personFatherName.trim());
            }
            if (searchParams.personSurName) {
                params.append('surname', searchParams.personSurName.trim());
            }
            if (searchParams.active !== undefined && searchParams.active !== null) {
                params.append('active', searchParams.active);
            }

            const queryString = params.toString();
            const url = `/doc-sign${queryString ? `?${queryString}` : ''}`;
            
            const response = await api.get(url);
            
            return response.data;
        } catch (error) {
            console.error('❌ [signeesService] Error getting signees:', error);
            throw error;
        }
    },
    getSigneesByCompany: async (companyId) => {
        const response = await api.get(`/doc-sign-by-company/${companyId}`);
        return response.data;
    },


addSignee: async (signee) => {
    try {
        const response = await api.post('/doc-sign', signee);
        return response.data;
    } catch (error) {
        console.error('Error adding signee:', error);
        throw error;
    }
},
    updateSignee: async (id, signeeData) => {
        try {
            const response = await api.put(`/doc-sign/${id}`, signeeData);
            return response.data;
        } catch (error) {
            console.error('Error updating signee:', error);
            throw error;
        }
    },
        deleteSignee: async (id) => {
            try {
                const response = await api.delete(`/doc-sign/${id}`);
                return response.data;
            } catch (error) {
                console.error('Error deleting signee:', error);
                throw error;
            }
        },
            searchPersons: async (searchParams = {}) => {
                try {
                    const params = new URLSearchParams();

                    if (searchParams.name) {
                        params.append('name', searchParams.name.trim());
                    }
                    if (searchParams.fathersName) {
                        params.append('fathersName', searchParams.fathersName.trim());
                    }
                    if (searchParams.surname) {
                        params.append('surname', searchParams.surname.trim());
                    }

                    const queryString = params.toString();
                    const url = `/persons${queryString ? `?${queryString}` : ''}`;
                    const response = await api.get(url);
                    return response.data;
                } catch (error) {
                    console.error('Error searching persons:', error);
                    throw error;
                }
            },
                getTranslation: async (signeeId) => {
                    try {
                        const response = await api.get(`/doc-sign/translation/${signeeId}`);
                        return response.data;
                    } catch (error) {
                        console.error('Error getting signee translation:', error);
                        throw error;
                    }
                },
                    saveTranslation: async (translationData) => {
                        try {
                            const response = await api.post('/doc-sign/translate', translationData);
                            return response.data;
                        } catch (error) {
                            console.error('Error saving signee translation:', error);
                            throw error;
                        }
                    }
}